export default __webpack_public_path__ + "static/media/form-bg.2cba1208.jpg";